import { ReactElement } from 'react';

import BackButton from '../buttons/BackButton';

import './HeaderWithBackButton.css';

interface HeaderWithBackButtonProps {
    pathname?: string;
    stateObject?: object;
    headerTitle: string;
    haveUnsavedChanges?: boolean;
    breadcrumbsRenderer?: () => ReactElement;
    editButtonRenderer?: () => ReactElement;
}

export const HeaderWithBackButton = (props: HeaderWithBackButtonProps) => {
    const titleAndBreadcrumbClass = props.breadcrumbsRenderer
        ? 'title-and-breadcrumbs'
        : 'title-without-breadcrumbs';
    return (
        <div style={{ overflow: 'hidden' }}>
            <div className='header-with-back-button header-title d-flex'>
                <BackButton
                    backUrl={props.pathname}
                    haveUnsavedChanges={props.haveUnsavedChanges}
                />
                <div className={titleAndBreadcrumbClass}>
                    <div className='header-title-content'>
                        {props.headerTitle}
                        {props.editButtonRenderer && props.editButtonRenderer()}
                    </div>
                    {props.breadcrumbsRenderer && (
                        <div>{props.breadcrumbsRenderer()}</div>
                    )}
                </div>
            </div>
        </div>
    );
};
